module["exports"] = [
  "co.kr",
  "com",
  "biz",
  "info",
  "ne.kr",
  "net",
  "or.kr",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/internet/domain_suffix.js
// module id = 2480
// module chunks = 2